import MainContent from "components/layout/MainContent";
import AppLoader from "components/common/AppLoader";
import { PageProvider } from "contexts/PageContext";
import AppModal from "components/common/AppModal";
import { useAuth } from "contexts/AuthContext";
import NavBar from "components/layout/Navbar";
import Footer from "components/layout/Footer";
import { useAppUI } from "contexts/UIContext";
import Analytics from "../Analytics";
import "./styles.scss";



function RootPage() {
  const { modalProps, appLoading } = useAppUI();
  const { token, loading, error } = useAuth();



  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center full-vh-height">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="indexpage">
        {error}
      </div>
    );
  }

  if (!token) {
    return (
      <div className="indexpage">
        Not authenticated. Please refresh and login.
      </div>
    );
  }



  return (
    <>
      {/* Analytics */}
      <Analytics />

      {/* Page Content */}
      <div id="rootPage">
        <PageProvider>
          <NavBar />
          <MainContent />
        </PageProvider>
        <Footer />
      </div>

      {/* Modal */}
      {modalProps ? (
        <AppModal {...modalProps} />
      ) : null}

      {/* Loader */}
      {appLoading ? (
        <AppLoader />
      ) : null}
    </>
  );
}

export default RootPage;